module.exports = __webpack_public_path__ + "img/icon1.c807509d.png";